import React from "react";
import { getAssets } from "@unisearch/helpers";
import { Grid } from "@mui/material";
import Link from "next/link";
import styles from "./styles/team.module.scss";
import TeamMemberCard from "@modules/study/common/team_member_card";

const data = [
  {
    id: 1,
    name: "Nafisa Shamim",
    designation: "CEO",
    link: "#",
    image: getAssets("assets/images/team/member1.png"),
  },
  {
    id: 2,
    name: "Habib Khan",
    designation: "CEO",
    link: "#",
    image: getAssets("assets/images/team/member2.png"),
  },
  {
    id: 3,
    name: "Dhrubo Gomez",
    designation: "CEO",
    link: "#",
    image: getAssets("assets/images/team/member3.png"),
  },
  {
    id: 4,
    name: "Mizan Khan",
    designation: "CEO",
    link: "#",
    image: getAssets("assets/images/team/member4.png"),
  },
];

export const AboutusTeam = () => {
  return (
    <section className={styles.section_team}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2>
            Our Amazing <span className="fw600">Team</span>
          </h2>

          <div className={styles.team_member_card_wrapper}>
            <Grid container spacing={4} alignItems="center">
              {data.map((member) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={member?.id}>
                  <TeamMemberCard
                    name={member.name}
                    link={member.link}
                    designation={member.designation}
                    image={member.image}
                  />
                </Grid>
              ))}
            </Grid>
          </div>

          <p className={styles.help_text}>
            Our nearly 8,000 committed
            <Link legacyBehavior href="/team">
              <a> staff members </a>
            </Link>
            are ready to help.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutusTeam;
